import React, { useState, useEffect, useContext } from "react";
import { globalInfo } from "../../App";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { Link } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import {
  getSingleSelectManufacturerDropdown,
  getSingleSelectSitesDropdown,
  submitFormData,
} from "../../Utils/adminFunctions";
import { Redirect } from "react-router-dom";
import {useNavigate } from "react-router-dom"

const AdminAddDevice = () => {
  const { ip_address } = useContext(globalInfo);
  const [listCompanies, setListCompanies] = useState("");
  const [listSites, setListSites] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [deviceImage, setDeviceImage] = useState("");
  const [deviceDescription, setDeviceDescription] = useState("");
  const [deviceCompanyName, setDeviceCompanyName] = useState("");
  const [deviceSiteName, setDeviceSiteName] = useState("");
  const [devicePreviewImage, setDevicePreviewImage] = useState("");
  const [errorDeviceName, setErrorDeviceName] = useState("");
  const [errorDeviceImage, setErrorDeviceImage] = useState("");
  const [errorDeviceCompanyName, setErrorDeviceCompanyName] = useState("");
  const [errorDeviceSiteName, setErrorDeviceSiteName] = useState("");
  const navigate = useNavigate()
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getSingleSelectManufacturerDropdown();
      if (response.status === "success") {
        setListCompanies(response.optionItems);
      } else {
        toast.error(response, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  let handleImageChange = (image) => {
    if (image) {
      setDeviceImage(image);
    } else {
      setDeviceImage("");
    }
    setDevicePreviewImage(URL.createObjectURL(image));
  };

  let getSites = (mID) => {
    if (mID === "") {
      setListSites("");
      return false;
    }
    let bodyFormData = new FormData();
    bodyFormData.append("manufacturer_id", mID);

    async function fetchAPI2() {
      const response = await getSingleSelectSitesDropdown(bodyFormData);
      if (response.status === "success") {
        setListSites(response.optionItems);
      } else {
        toast.error(response, { autoClose: 1500 });
      }
    }
    fetchAPI2();
  };

  const submitDevice = async () => {
    let errorRequiredFiled = 0;
    if (deviceName === "") {
      setErrorDeviceName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (deviceImage === "") {
      setErrorDeviceImage("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (deviceImage !== "" && !deviceImage.name.match(/\.(jpg|jpeg|png)$/)) {
      toast.warning("Select valid image", { autoClose: 1500 });
      return false;
    }

    if (deviceImage !== "" && deviceImage.size > 2000000) {
      toast.warning("Maximum filesize limit exceeded", { autoClose: 1500 });
      return false;
    }

    if (deviceCompanyName === "") {
      setErrorDeviceCompanyName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (deviceSiteName === "") {
      setErrorDeviceSiteName("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }

    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      return false;
    }
    const bodyFormData = new FormData();
    if (deviceImage !== null) {
      bodyFormData.append("device_image", deviceImage);
    }
    bodyFormData.append("device_name", deviceName);
    bodyFormData.append("description", deviceDescription);
    bodyFormData.append("description", deviceDescription);
    bodyFormData.append("manufacturer_id", deviceCompanyName);
    bodyFormData.append("site_id", deviceSiteName);
    bodyFormData.append("entered_by_ip", ip_address);
    const response = await submitFormData("addDevice", bodyFormData);
    if (response.status === "success") {
      setDeviceName("");
      setDeviceImage("");
      setDeviceDescription("");
      setDeviceCompanyName("");
      setDeviceSiteName("");
      setListSites("");
      setDevicePreviewImage("");
      document.getElementById("deviceImage").value = "";
      toast.success(response.message, { autoClose: 1500 });
      // window.location.href = `/AdminListDevices`;
        // navigate to previous page after success
        navigate(`/AdminListDevices`);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
    }
  };

  return (
    <div>
      <div className="wrapper">
        <div>
         
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="card-tools">
                          <div className="col-md-12">
                            <Link
                              to="/AdminListDevices"
                              className="btn btn-sm custom-btn-primary"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        {devicePreviewImage && (
                          <>
                            <img src={devicePreviewImage} height="90"></img>
                          </>
                        )}

                        <div className="row">
                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Device Name<i className="text-danger">*</i>
                              </span>
                              <input
                                type="text"
                                className={
                                  "form-control" +
                                  (errorDeviceName ? " is-invalid" : "")
                                }
                                value={deviceName}
                                onChange={(e) => {
                                  setDeviceName(e.target.value);
                                  setErrorDeviceName("");
                                }}
                                placeholder="Device Name"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Device Image<i className="text-danger">*</i>
                                <small> (max file size 2MB)</small>
                              </span>
                              <input
                                type="file"
                                accept="image/*"
                                className={
                                  "form-control" +
                                  (errorDeviceImage ? " is-invalid" : "")
                                }
                                id="deviceImage"
                                onChange={(e) => {
                                  setErrorDeviceImage("");
                                  handleImageChange(e.target.files[0]);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Device Description
                              </span>
                              <textarea
                                className="form-control"
                                rows={3}
                                placeholder="Enter ..."
                                value={deviceDescription}
                                onChange={(e) => {
                                  setDeviceDescription(e.target.value);
                                }}
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Company Name<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorDeviceCompanyName ? " is-invalid" : "")
                                }
                                id="deviceCompanyName"
                                name="deviceCompanyName"
                                value={deviceCompanyName}
                                onChange={(e) => {
                                  setDeviceCompanyName(e.target.value);
                                  setErrorDeviceCompanyName("");
                                  getSites(e.target.value);
                                }}
                              >
                                <option value="">Select</option>
                                {listCompanies}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <span className="custom-label-font-weight">
                                Site Name<i className="text-danger">*</i>
                              </span>
                              <select
                                className={
                                  "form-control" +
                                  (errorDeviceSiteName ? " is-invalid" : "")
                                }
                                id="deviceSiteName"
                                name="deviceSiteName"
                                value={deviceSiteName}
                                onChange={(e) => {
                                  setDeviceSiteName(e.target.value);
                                  setErrorDeviceSiteName("");
                                }}
                              >
                                <option value="">Select</option>
                                {listSites}
                              </select>
                            </div>
                          </div>

                          <div className="col-md-12">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary pull-right"
                              onClick={submitDevice}
                            >
                              Submit
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminAddDevice;
